export default {
    categories:[],
    category:{},
}
